'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.newStickFeedDataHandle = void 0;
var stickFeedDataFormatHandle = function (e) {
        var n = [];
        return e.forEach(function (e) {
            var t = [];
            t.push(e), e.children && e.children.forEach(function (e) {
                t.push(e);
            }), t = t.map(function (e, t) {
                return {
                    id: e.id,
                    type: e.type,
                    title: e.title,
                    url: e.url,
                    stick: e.stick,
                    source: e.source,
                    base62Id: e.base62Id,
                    commentUrl: e.commentUrl,
                    index: t
                };
            }), n.push(t);
        }), n;
    }, feedRandomDataHandle = function (e, t, n) {
        return e[Math.floor(Math.random() * t)];
    }, newStickFeedDataHandle = function (e) {
        if (!e || 0 === e.length)
            return e;
        var t = stickFeedDataFormatHandle(e), a = [];
        return t.forEach(function (e, t) {
            var n = [];
            1 === e.length && (n = e[0]), 1 < e.length && (n = feedRandomDataHandle(e, e.length, t)), a.push(n);
        }), a;
    };
exports.newStickFeedDataHandle = newStickFeedDataHandle;